import { getClientPath } from '@app/modules/ClientsProfile'

export function getMessagesPath(id: number | string) {
  return `${getClientPath(id)}/beratung`
}
